import $ from 'jquery';
import './components/Tabs.mjs';
import Alert from './components/Alert.mjs';
import GoogleMapsLoader from './components/GoogleMapsLoader.mjs';
import FormRestartSearch from './components/FormRestartSearch.mjs';
import Map from './components/Map.mjs';
import OpeningHours from './components/OpeningHours.mjs';
import Directions from './components/Directions.mjs';
import StoreList from './components/StoreList.mjs';
import {storesIsOpenForBusiness} from "./utilities/store-filters.mjs";

const SEARCH_MAXITEMS = 5;
const storeDetails = JSON.parse($('#page-store-details').text());
const currentStore = storeDetails.currentStore;
const furtherStores = storeDetails.furtherStores.filter(storesIsOpenForBusiness).slice(0, SEARCH_MAXITEMS);

/*
 * Initialize map
 */
GoogleMapsLoader.load().then((google) => {
  // Add current store marker
  Map.setCurrentStore(currentStore.street, new google.maps.LatLng({
    lat: currentStore.latitude,
    lng: currentStore.longitude,
  }));

  // Add further stores markers
  Map.setStoresNearby(furtherStores).finally(() => {
    // Center map even if there are no further stores (finally)
    Map.centerMapToBounds();

    // Center map again if switching from other tabs to tab with the map for the first time
    const $tabToggles = $('[data-toggle="tab"]');
    $tabToggles.first().on('shown.bs.tab.Map', () => {
      Map.centerMapToBounds();
      $tabToggles.first().off('shown.bs.tab.Map');
    });
  });
}).catch((exception) => {
  console.log('PageStoreDetail - Error GoogleMapsLoader:', exception);
});

/*
 * Initialize opening hours
 */
const $openingHoursHolder = $('#store-opening-hours-holder');
new OpeningHours(currentStore).render().then(($node) => {
  $openingHoursHolder.html($node);

  if (storeDetails.openingHoursAlert.length < 1) {
    // Do nothing
    return;
  }

  // Add alert with further explanations
  const $alert = new Alert({
    'additionalClasses': 'mt-3',
    'typeInfo': true,
    'iconId': 'info',
    'copytext': storeDetails.openingHoursAlert,
  });
  $node.find('.opening-hours__table').before($alert);
});

/*
 * Form for starting a new search
 */
const $formRestartSearch = $('.js_form-restart-search');
if ($formRestartSearch.length) {
  $formRestartSearch.each((index, form) => {
    new FormRestartSearch(form).init();
  });
}

/*
 * Directions
 */
const $directions = $('.js_directions');
if ($directions.length) {
  $directions.each((index, form) => {
    new Directions(form);
  });
}

/*
 * Further store list
 */
const $storeListHolder = $('#store-list-holder');
if ($storeListHolder.length) {
  new StoreList($storeListHolder, currentStore, furtherStores);
}
